import { IconName } from '@aidkitorg/component-library/dist/types/src/Icon';
import { DashboardWithId } from '@aidkitorg/types/lib/survey';
import { isReviewDashboard } from '../utils/dashboardUtils';

export type DashboardPaletteCommand = {
  id: string;
  label: string;
  description?: string;
  href: string;
  iconName: IconName;
  category: 'dashboards';
  priority: number;
};

function resolveLocalizedText(
  value: string | { en: string; [key: string]: string | undefined } | undefined,
  lang?: string
): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return (lang && value[lang]) || value.en || '';
}

export function mapDashboardsToPaletteCommands(
  dashboards: DashboardWithId[],
  options: {
    lang?: string;
    canViewDashboards: boolean;
    canViewReviewQueues: boolean;
  }
): DashboardPaletteCommand[] {
  const { lang, canViewDashboards, canViewReviewQueues } = options;
  const commands: DashboardPaletteCommand[] = [];

  for (const dashboard of dashboards) {
    const title = resolveLocalizedText(dashboard.title, lang);
    if (!title || !dashboard.id) continue;

    const review = isReviewDashboard(dashboard);
    if (review && !canViewReviewQueues) continue;
    if (!review && !canViewDashboards) continue;

    const href = review
      ? `/admin-panel/reviews/queues/${dashboard.id}`
      : `/admin-panel/dashboards/${dashboard.id}`;

    const description = resolveLocalizedText(dashboard.description, lang);

    commands.push({
      id: `dashboard-${dashboard.id}`,
      label: title,
      description: description || undefined,
      href,
      iconName: 'PresentationChartBarIcon',
      category: 'dashboards',
      priority: 0,
    });
  }

  return commands;
}
